"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _default = function _default() {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    as: "h4",
    color: "green",
    style: {
      marginTop: '0'
    }
  }, "Successfully sent!");
};

exports["default"] = _default;